export const mainRoles = ["preparer","verifier","issuer"]
export const userRoles = "user" 
  